export const LIGHT_COLOR_CATEGORIES = ['Life-wide behaviours', 'Interests and application', 'Production experience'];
